
import React, { useState } from "react";
import "./style.scss";
import MarketingNavbar from "../../components/marketingNavbar";
import HeroSection from "./partials/hero";
import AboutSection from "./partials/aboutSection";
import CardsSection from "./partials/cardsSection";
import Footer from "../../components/footer";
import ApplyForm from "./partials/applyForm";

const Home = () => {

  const [modalShow, setModalShow] = useState(false);

  const openModal = () => setModalShow(true);

  return (
    <div>
      <MarketingNavbar isAbsolute />
      <HeroSection openModal={openModal} />
      <AboutSection />
      <CardsSection />
      <Footer />
      <ApplyForm
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

export default Home;
